const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect width="20" height="20" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6965 12.5703L16.9798 15.912C17.1269 16.071 17.2063 16.281 17.2012 16.4975C17.1961 16.714 17.1069 16.9201 16.9525 17.072C16.7982 17.2239 16.5907 17.3097 16.3741 17.3113C16.1575 17.3128 15.9489 17.23 15.7923 17.0803L12.5106 13.742C11.2444 14.6959 9.66304 15.133 8.08669 14.9647C6.51035 14.7965 5.05684 14.0355 4.02048 12.8358C2.98411 11.6362 2.44234 10.0876 2.50487 8.50351C2.56739 6.91944 3.22953 5.41833 4.35722 4.30411C5.48491 3.18989 6.99388 2.54583 8.57858 2.50235C10.1633 2.45887 11.7053 3.01921 12.8924 4.06992C14.0795 5.12063 14.8229 6.58317 14.9722 8.16143C15.1215 9.73968 14.6655 11.3157 13.6965 12.5703ZM8.7498 13.3328C9.96537 13.3328 11.1312 12.85 11.9907 11.9904C12.8502 11.1309 13.3331 9.96509 13.3331 8.74952C13.3331 7.53394 12.8502 6.36815 11.9907 5.50861C11.1312 4.64907 9.96537 4.16618 8.7498 4.16618C7.53422 4.16618 6.36843 4.64907 5.50889 5.50861C4.64935 6.36815 4.16646 7.53394 4.16646 8.74952C4.16646 9.96509 4.64935 11.1309 5.50889 11.9904C6.36843 12.85 7.53422 13.3328 8.7498 13.3328Z"
      fill="#A5ADBA"
    />
  </svg>
);

export default SearchIcon;
